import { memo }from "react";
import { useWelcomeSectionStyles } from "./WelcomeSectionStyles";
import { MBox, MButton, MTypography } from "@material-dev/insights-portal-ui-components";
import { useAppDispatch } from "@store";
import { openHelpDrawer } from "slices/dashboard/dashboardSlice";
import { ReactComponent as DMLogo } from 'images/newDatamanager.svg'

const WelcomeSection: React.FC = () => {
  const { classes } = useWelcomeSectionStyles();
  const dispatch = useAppDispatch();

  return (
    <MBox className={classes.root}>
      <MTypography className={classes.logoContainer}>
          <DMLogo className={classes.logoImage} />
          <span className={classes.logoText}>Data Manager</span>
      </MTypography>
      <MTypography className={classes.heading}>
        Welcome to Data Manager!<br />
        Start exploring and check out useful guidelines and tips in the Help section.
      </MTypography>
      <MTypography className={classes.description}>
        Data Manager is a cloud-based data management and manipulation platform. Automatically clean, validate, <br />translate, and prepare survey data for analysis with built-in AI, stacking, and export tools—all in one place.
      </MTypography>
      <MBox className={classes.actions}>
        <MButton variant="contained" color="primary" size="large" onClick={()=>dispatch(openHelpDrawer())} className={classes.learnmorebutton} >
          Learn more about Data Manager
        </MButton>
      </MBox>
    </MBox>
  );
};

export default memo(WelcomeSection);
